import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faChevronDown, faLock, faCircle, faCircleDot, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ProgressBar from '../academy/components/ProgressBar';

const CourseHero = ({
  courseTitle,
  level,
  chapter,
  lesson,
  currentLesson,
  completedLessons,
  totalLessons,
  completedQuestions = [],
  maxQuestions = 0,
  lessonOptions,
  onLessonChange,
  onLevelChange,
  isIntermediateUnlocked,
  showHero,
  isAnimating,
  onToggleHero,
  currentQuestion = 0,
  onQuestionChange = () => {},
  totalQuestions = 0
}) => {
  return (
    <div className="course-hero-container">
      {showHero && (
        <div className="hero is-small" style={{ backgroundColor: 'rgba(25, 25, 25, 0.8)' }}>
          <div className="hero-body">
            <div className="container has-text-centered" style={{ position: 'relative' }}>
              <button 
                className="course-hero-close-button" 
                onClick={onToggleHero}
                aria-label="Close course info"
              >
                <FontAwesomeIcon icon={faXmark} />
                <span className="course-hero-close-text">Hide panel</span>
              </button>
              <div className="has-text-centered" style={{ marginTop: '2.5rem' }}>
                <h1 className="title has-text-warning mb-2">{courseTitle}</h1>
                <p className="has-text-warning is-size-7 mb-3">{level.charAt(0).toUpperCase() + level.slice(1)} Level</p>
                <p className="has-text-grey-light is-italic mb-1" style={{ pointerEvents: 'none', userSelect: 'none' }}>{chapter}</p>
                <p className="has-text-grey-light is-italic mb-2" style={{ pointerEvents: 'none', userSelect: 'none' }}>{lesson}</p>
                <div className="field mt-4 mb-3">
                  <div className="control is-expanded">
                    <div className="level">
                      <div className="level-item">
                        <label htmlFor="lesson-dropdown" className="mr-1 has-text-white" style={{ fontWeight: 600, background: 'none', border: 'none', boxShadow: 'none', padding: 0, margin: 0, display: 'inline' }}>Lesson:</label>
                        <div className="select">
                          <select
                            id="lesson-dropdown"
                            value={currentLesson}
                            onChange={onLessonChange}
                            className="is-small"
                          >
                            <option value="course-foreword">Course Foreword</option>
                            {lessonOptions}
                            <option value="course-endword">Course End Word</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ProgressBar 
                  completedLessons={completedLessons}
                  totalLessons={totalLessons}
                />
                {maxQuestions > 0 && (
                  <p className="course-hero-progress-text">
                    {`${completedQuestions.filter(Boolean).length} of ${maxQuestions} questions in this lesson completed`}
                  </p>
                )}
                <div className="buttons is-centered mt-3">
                  <button className="button is-small is-warning" onClick={() => onLevelChange("beginner")}>Beginner</button>
                  <button 
                    className={`button is-small ${isIntermediateUnlocked ? 'is-grey' : 'is-locked'}`}
                    onClick={() => onLevelChange("intermediate")}
                    disabled={!isIntermediateUnlocked}
                    title={isIntermediateUnlocked ? 'Intermediate level unlocked' : 'Complete beginner course to unlock intermediate level'}
                  >
                    {!isIntermediateUnlocked && <FontAwesomeIcon icon={faLock} className="lock-icon" />}
                    Intermediate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {!showHero && (
        <div className="course-hero-collapsed">
          <div className="course-hero-collapsed-top">
            <span className="course-hero-label">Lesson controls</span>
            <button 
              className="button course-hero-toggle-button" 
              onClick={onToggleHero}
            >
              <FontAwesomeIcon icon={faChevronDown} className="has-text-white" />
              <span className="course-hero-toggle-text">Open panel</span>
            </button>
          </div>
          {totalQuestions > 0 ? (
            <div className="course-hero-mini-controls">
              <button 
                className="button course-hero-nav-arrow-button" 
                onClick={() => onQuestionChange(currentQuestion - 1)}
                disabled={currentQuestion === 0}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
                <span className="course-hero-nav-text">Prev</span>
              </button>
              <div className="course-hero-mini-progress">
                <span className="course-hero-progress-text">
                  {`${completedQuestions.filter(Boolean).length} / ${maxQuestions} questions`}
                </span>
                <div className="course-hero-dots-container">
                  {Array.from({ length: totalQuestions }, (_, index) => (
                    <FontAwesomeIcon
                      key={index}
                      icon={completedQuestions[index] ? faCircleDot : faCircle}
                      className={`course-hero-dot-icon ${currentQuestion === index ? 'is-active' : ''}`}
                      onClick={() => onQuestionChange(index)}
                    />
                  ))}
                </div>
              </div>
              <button 
                className="button course-hero-nav-arrow-button" 
                onClick={() => onQuestionChange(currentQuestion + 1)}
                disabled={currentQuestion >= totalQuestions - 1}
              >
                <span className="course-hero-nav-text">Next</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          ) : (
            <div className="course-hero-mini-controls">
              <span className="course-hero-progress-text">
                Lesson panel hidden. Use the button above to reopen the navigator.
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CourseHero; 
